import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import fuzzy from "fuzzy";

import MenuTabs from "./components/MenuTabs";
import { HeaderText } from "../../common/common.styles";
import { OrderHistoryContainer, OrderHistoryWrapper } from "./orderHistory.styles";
import PlainSearchInput from "../../../../library/SearchInput/PlainSearch";
import Orders from "./components/Orders";
import { useFetchOrderHistory } from "../../common/hooks/useFetchSalesOrderData";

const OrderHistory = () => {
    const [activePage, setActivePage] = useState(0);
    const [searchString, setSearchString] = useState("");
    const { orderHistory } = useSelector((state) => state.catalogueState);

    const orderData = useMemo(() => {
        if (activePage === 0) {
            return orderHistory?.filter((order) => order.status === 1) || [];
        } else if (activePage === 1) {
            return orderHistory?.filter((order) => order.status === 3) || [];
        } else if (activePage === 2) {
            return orderHistory?.filter((order) => order.status === 2) || [];
        }
    }, [activePage, orderHistory]);

    const searchedItems = useMemo(() => {
        if (!searchString) return orderData;
        const options = {
            extract: function (el) {
                return `${el.name} ${el.orderID}`;
            },
        };
        const result = fuzzy.filter(searchString, orderData, options);
        return result.map((el) => el.original);
    }, [searchString, orderData]);

    const onSetActivePage = (index) => setActivePage(index);

    const getCatalogueOrders = useFetchOrderHistory();

    useEffect(() => {
        getCatalogueOrders();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <OrderHistoryContainer>
            <OrderHistoryWrapper>
                <HeaderText>Order History</HeaderText>
                <MenuTabs {...{ activePage, onSetActivePage }} />
                {activePage === 2 && orderData?.length > 0 && (
                    <PlainSearchInput
                        placeholder={"Search Order"}
                        width="320px"
                        {...{ searchString, setSearchString }}
                    />
                )}
                <Orders {...{ searchedItems, activePage }} />
            </OrderHistoryWrapper>
        </OrderHistoryContainer>
    );
};

export default OrderHistory;
